import BaseModelService from '../../base/base_model_service';

class PendingActionModel extends BaseModelService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'PendingActionModel';


    /**
     * Initialize 
     *
     * @param params
     */
    init(params) {
        if (!params) {
            return;
        }
    }

}

export default PendingActionModel;